<rt-input
  #dropdownOrigin="rtOverlayOrigin"
  variant="rounded"
  [value]="currentSelection && currentSelection.value"
  [hasClearButton]="true"
  [focusOnClear]="false"
  [disabled]="!professionCategory"
  (focus)="dropdown.open = true"
  (reset)="dropdown.open = false; professionSelected.emit(null)"
  class="profession-input"
  rt-overlay-origin
/>

<ng-template
  #dropdown="rtConnectedOverlay"
  [origin]="dropdownOrigin"
  [width]="450"
  [open]="dropdown.open"
  [positions]="dropdownPositions"
  (backdropClick)="dropdown.open = false"
  (detach)="queryControl.setValue(null); suggestions = []"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown [width]="DropdownWidth.FullWidth">
    <rt-typeahead-inline
      #typeahead="rtTypeahead"
      [loading]="suggestionsLoading"
      [active]="dropdown.open"
      [value]="queryControl.value"
      [suggestions]="suggestions"
      [suggestionsTemplate]="suggestionsTemplate"
      (selected)="professionSelected.emit($event); dropdown.open = false"
    >
      <div padding-small-x>
        <rt-form-field (click)="$event.preventDefault()" margin-bottom-small>
          <rt-input
            #inputComponent
            [value]="queryControl.value"
            [autoFocus]="true"
            [hasClearButton]="!!queryControl.value"
            (valueChange)="queryControl.setValue($event === '' ? null : $event)"
            variant="rounded"
            placeholder="{{ 'app.common.search' | translate }}"
          >
            <rt-icon prefix name="search" />
          </rt-input>
        </rt-form-field>
      </div>
    </rt-typeahead-inline>

    <ng-template #suggestionsTemplate let-typeaheadstate="typeaheadstate">
      <rt-dropdown [width]="DropdownWidth.FullWidth">
        <rt-typeahead-suggestions
          [stateName]="typeaheadstate.name"
          [stateValue]="typeaheadstate.value"
          [suggestions]="typeaheadstate.suggestions"
          [highlighted]="typeaheadstate.highlighted"
          [suggestionItemTemplate]="companySelectSuggestionItemTemplate"
          [wrapBody]="false"
        />
      </rt-dropdown>
    </ng-template>

    <ng-template
      #companySelectSuggestionItemTemplate
      let-highlighted="highlighted"
      let-suggestion="suggestion"
      let-label="label"
      let-select="select"
    >
      <rt-dropdown-item
        [highlighted]="suggestion.id === highlighted"
        (click)="typeahead.select(suggestion)"
      >
        <div layout-vertical>
          <div>{{ suggestion.value }}</div>
        </div>
      </rt-dropdown-item>
    </ng-template>
  </rt-dropdown>
</ng-template>
